import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { useServices } from "../../lib/api";

export const ServicesGrid = () => {
  const { data: services = [] } = useServices();

  return (
    <section data-testid="services-section" className="bg-canvas py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="overline-label mb-4">01 — What We Build</p>
            <h2 className="font-heading font-medium text-3xl md:text-4xl tracking-tight text-ink max-w-xl">
              Six disciplines. One standard of execution.
            </h2>
          </div>
          <Link
            to="/services"
            data-testid="services-view-all"
            className="inline-flex items-center gap-2 text-sm font-medium text-blueprint hover:gap-3 transition-all"
          >
            View all services <ArrowUpRight size={16} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-6">
          {services.map((svc, i) => (
            <motion.div
              key={svc.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.12 }}
              className={i === 0 ? "md:col-span-4" : i === 1 ? "md:col-span-2" : "md:col-span-3"}
            >
              <Link
                to="/services"
                data-testid={`service-card-${svc.slug}`}
                className="group relative block h-72 md:h-80 overflow-hidden border border-line"
              >
                <img
                  src={svc.image}
                  alt={svc.name}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <p className="font-mono-tech text-[10px] tracking-[0.22em] uppercase text-[#FFD60A] mb-2">
                    0{svc.order} / {svc.slug.replace(/-/g, " ")}
                  </p>
                  <h3 className="font-heading font-medium text-2xl tracking-tight text-white flex items-center gap-2">
                    {svc.name}
                    <ArrowUpRight size={18} className="opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all" />
                  </h3>
                  <p className="mt-1.5 text-sm text-white/60 line-clamp-2">{svc.tagline}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
